import { useEffect, useState } from "react";
import { getCookie, setCookie } from "@/utils/cookiesUtils";
import { dntCookieName, dntCookieOptions } from "./constants";

export function useDntCookie() {
  const [dntCookie, setDntCookie] = useState<boolean | null>(null);

  useEffect(() => {
    const cookie = getCookie(dntCookieName);
    if (cookie) {
      setDntCookie(cookie === "true");
    }
  }, []);

  const updateDntCookie = (value: boolean | null) => {
    if (value === null) {
      setCookie(dntCookieName, "", 0);
    } else {
      setCookie(dntCookieName, value.toString(), dntCookieOptions.expires);
    }
    setDntCookie(value);
  };

  return [dntCookie, updateDntCookie] as const;
}
